import React, { useState, useEffect } from "react";
import EditPopup from "../../EditPopup/EditPopup";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import {
  faFacebook,
  faInstagram,
  faTiktok,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";
import {
  updateSocialNetworkLink,
  updateEmail,
  updateContactNumber,
  getUserDetails, // Ensure this is imported correctly
  updateAddress
} from "../../../api/axios";
import HeadshotUpload from "../../EditPopup/HeadshotUpload";
import Alert from "../../common/Alert";
import AddressPopup from "../../EditPopup/AddressPopup";

const socialMediaIcons = {
  facebook: faFacebook,
  instagram: faInstagram,
  tiktok: faTiktok,
  youtube: faYoutube,
};

// Extract @domain from URL
const extractUsername = (url) => {
  try {
    const hostname = new URL(url).hostname;
    return "@" + hostname.replace("www.", "").split(".")[0];
  } catch {
    return "";
  }
};

const ProfileSidebar = ({
  setHeadshot,
  userDetails,
  GetUserDetails,
  userId,
}) => {
  const [isEmailPopupVisible, setIsEmailPopupVisible] = useState(false);
  const [isContactPopupVisible, setIsContactPopupVisible] = useState(false);
  const [isSocialPopupVisible, setIsSocialPopupVisible] = useState(false);
  const [isAddressPopupVisible, setIsAddressPopupVisible] = useState(false);
  const [socialNetworks, setSocialNetworks] = useState({
    facebook: userDetails?.result?.fbLink || "",
    instagram: userDetails?.result?.instagramLink || "",
    tiktok: userDetails?.result?.tikTokLink || "",
    youtube: userDetails?.result?.youtubeLink || "",
  });
  const [currentSocialNetwork, setCurrentSocialNetwork] = useState({});
  const [isEditingSocialNetwork, setIsEditingSocialNetwork] = useState(false);

  // State for managing alerts
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [alertSeverity, setAlertSeverity] = useState("success");
  const [alertMessage, setAlertMessage] = useState("");

  const userMainDetails = userDetails?.registerResult || {};

  // Initialize local state with userMainDetails
  const [email, setEmail] = useState(
    userMainDetails.email || "example@example.com"
  );
  const [contactNumber, setContactNumber] = useState(
    userMainDetails.contactNumber || "123-456-7890"
  );

  //Assinging a default value for address
  const [address, setAddress] = useState(userDetails?.result?.address || "");

  const role = userDetails?.result?.role || userDetails?.registerResult?.role;

  useEffect(() => {
    setEmail(userMainDetails.email || "example@example.com");
    setContactNumber(userMainDetails.contactNumber || "123-456-7890");
  }, [userMainDetails]);


  // useEffect(() => {
  //   const socialLinks = userDetails.user.result || {};

  //       setSocialNetworks({
  //         facebook: socialLinks.fbLink || "",
  //         instagram: socialLinks.instagramLink || "",
  //         tiktok: socialLinks.tikTokLink || "",
  //         youtube: socialLinks.youtubeLink || "",
  //       });
  // }, [userId]);

  const handleEditClick = (type) => {
    if (type === "email") {
      setIsEmailPopupVisible(true);
    } else if (type === "contact") {
      setIsContactPopupVisible(true);
    } else if (type === "address") {
      setIsAddressPopupVisible(true);
    } else if (type === "social") {
      setCurrentSocialNetwork(socialNetworks);
      setIsEditingSocialNetwork(true);
      setIsSocialPopupVisible(true);
    }
  };

  const handleAddClick = () => {
    setCurrentSocialNetwork({
      facebook: "",
      instagram: "",
      tiktok: "",
      youtube: "",
    });
    setIsEditingSocialNetwork(false);
    setIsSocialPopupVisible(true);
  };

  const handleSaveEmail = async (newEmail) => {
    try {
      const updatedUser = await updateEmail(userId, newEmail.email);
      // console.log("API Response:", updatedUser);
      if (updatedUser) {
        setEmail(newEmail.email);
        GetUserDetails(); // Optionally refresh user details
        // Trigger success alert
        setAlertMessage("Email updated successfully!");
        setAlertSeverity("success");
        setOpenSnackbar(true);
      }
    } catch (error) {
      console.error("Error updating email:", error);
      // Trigger error alert
      setAlertMessage("Failed to update email.");
      setAlertSeverity("error");
      setOpenSnackbar(true);
    }
    setIsEmailPopupVisible(false);
  };

  const handleSaveContact = async (newContact) => {
    try {
      const updatedUser = await updateContactNumber(
        userId,
        newContact.contactNumber
      );
      if (updatedUser) {
        setContactNumber(newContact.contactNumber);
        GetUserDetails(); // Optionally refresh user details
        // Trigger success alert
        setAlertMessage("Contact number updated successfully!");
        setAlertSeverity("success");
        setOpenSnackbar(true);
      }
    } catch (error) {
      console.error("Error updating contact number:", error);
      // Trigger error alert
      setAlertMessage("Failed to update contact number.");
      setAlertSeverity("error");
      setOpenSnackbar(true);
    }
    setIsContactPopupVisible(false);
  };

  const handleSaveAddress = async (newAddress) => {
    try {
      const updatedUser = await updateAddress(userId, newAddress.address, role);
      if (updatedUser) {
        setAddress(newAddress.address);
        GetUserDetails(); 
        setAlertMessage("Address updated successfully!");
        setAlertSeverity("success");
        setOpenSnackbar(true);
      }
    } catch (error) {
      console.error("Error updating address:", error);
      setAlertMessage("Failed to update address.");
      setAlertSeverity("error");
      setOpenSnackbar(true);
    }
    setIsAddressPopupVisible(false);
  };

  const handleSaveSocialNetwork = async (newSocialNetworks) => {
    try {
      for (const [platform, link] of Object.entries(newSocialNetworks)) {
        if (link) {
          await updateSocialNetworkLink(userId, platform, link, role);
        }
      }
      setSocialNetworks(newSocialNetworks);
      setAlertMessage("Social networks updated successfully!");
      setAlertSeverity("success");
      setOpenSnackbar(true);
    } catch (error) {
      console.error("Error updating social networks:", error);
      setAlertMessage("Failed to update social networks.");
      setAlertSeverity("error");
      setOpenSnackbar(true);
    }
    setIsSocialPopupVisible(false);
  };

  const handleClosePopup = () => {
    setIsEmailPopupVisible(false);
    setIsContactPopupVisible(false);
    setIsSocialPopupVisible(false);
    setIsAddressPopupVisible(false);
  };

  return (
    <div className="log-profile-sidebar">
      <HeadshotUpload
        setHeadshot={setHeadshot}
        imgUrl={userMainDetails?.imageURL}
        GetUserDetails={GetUserDetails}
        userId={userId}
      />
      <div className="log-profile-contact-info">
        <div className="log-contact-option">
          <div className="log-contact-label">
            <span>Email</span>
            <FontAwesomeIcon
              icon={faEdit}
              className="editIcon"
              onClick={() => handleEditClick("email")}
            />
          </div>

          <div
            style={{ maxWidth: "100%" }}
            className="log-profile-details-box-side"
          >
            {email}
          </div>
        </div>
        <div className="log-contact-option">
          <div className="log-contact-label">
            <span>Contact Number</span>
            <FontAwesomeIcon
              icon={faEdit}
              className="editIcon"
              onClick={() => handleEditClick("contact")}
            />
          </div>
          <div className="log-profile-details-box-side">{contactNumber}</div>
        </div>

        <div className="log-contact-option">
          <div className="log-contact-label">
            <span>Address</span>
            <FontAwesomeIcon
              icon={faEdit}
              className="editIcon"
              onClick={() => handleEditClick("address")}
            />
          </div>
          <div className="log-profile-details-box-side">
            {(address) ? address : <div className="clickable-text" style={{color:'#6E0506'}} onClick={() => handleEditClick("address")}>Add Address</div>}
          </div>
        </div>
        <div className="log-contact-option" style={{ marginBottom: "20px" }}>
          <div className="log-contact-label" style={{ marginBottom: "10px" }}>
            <span>Social Networks</span>
            <FontAwesomeIcon
              icon={faEdit}
              className="editIcon"
              onClick={() => handleEditClick("social")}
            />
          </div>

          <div
            className="log-profile-details-box-side"
            style={{
              display: "grid",
              gap: "10px",
              gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
            }}
          >
            {Object.entries(socialNetworks).every(([key, value]) => !value) ? (
              <p
                className="clickable-text"
                onClick={() => handleEditClick("social")}
                style={{
                  cursor: "pointer",
                  color: "#6E0506",
                  textDecoration: "underline",
                }}
              >
                Add social network URLs
              </p>
            ) : (
              Object.entries(socialNetworks).map(
                ([key, value]) =>
                  value && (
                    <a
                      href={value}
                      key={key}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="social-network-item"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent:'start',
                        gap: "10px",
                        textDecoration: "none",
                        padding: "10px",
                        border: "1px solid  #6E0506",
                        borderRadius: "4px",
                        backgroundColor: "#f9f9f9",
                      }}
                    >
                      <FontAwesomeIcon
                        icon={socialMediaIcons[key]}
                        size="lg"
                        style={{ color: "#6E0506" }}
                      />
                        <span style={{color: "#6E0506"}}>{extractUsername(value)}</span>
                    </a>
                  )
              )
            )}
          </div>
        </div>
      </div>

      {isEmailPopupVisible && (
        <EditPopup
          title="Edit Email"
          fields={{ email }}
          onSave={handleSaveEmail}
          onClose={handleClosePopup}
        />
      )}
      {isContactPopupVisible && (
        <EditPopup
          title="Edit Contact Number"
          fields={{ contactNumber }}
          onSave={handleSaveContact}
          onClose={handleClosePopup}
        />
      )}
      {isAddressPopupVisible && (
        <AddressPopup
          id = {userId}
          role = {role}
          address={address}  
          setVisible={setIsAddressPopupVisible}
          setOpenSnackbar={setOpenSnackbar}
          setAlertMessage={setAlertMessage}
          setAlertSeverity={setAlertSeverity}
          setAddress={setAddress}
        />
      )}
      {isSocialPopupVisible && (
        <EditPopup
          title={
            isEditingSocialNetwork
              ? "Edit Social Networks"
              : "Add Social Networks"
          }
          fields={currentSocialNetwork}
          onSave={handleSaveSocialNetwork}
          onClose={handleClosePopup}
        />
      )}

      {/* Alert Component */}
      <Alert
        openSnackbar={openSnackbar}
        alertSeverity={alertSeverity}
        setOpenSnackbar={setOpenSnackbar}
        alertMessage={alertMessage}
      />
    </div>
  );
};

export default ProfileSidebar;
